import React from "react";
import { VerifyEmail } from "components/auth/verifyEmail";

export const VerifyEmailPage = () => {
  return <VerifyEmail />;
};

export default VerifyEmailPage;
